import { useState } from 'react';
import { useEstabsContext } from '../../../contexts/EstabsContext';
import { useParamsContext } from '../../../contexts/ParamsContext';
import { urlFile } from '../../../AxiosConfig';
import { ViewEstabInfoModal } from '../componentes/ViewEstabInfoModal';
import { UserClientEstabAdd } from './AddFirst';
import { ChevronRight, Store } from 'lucide-react';

const MyEstablishments = () => {
    const { estabsUser } = useEstabsContext();
    const { setParams } = useParamsContext();
    const [openId, setOpenId] = useState('');
    const estabs = estabsUser.filter((e) => e.type === 'client');

    if (!estabs.length) {
        return (
            <div className="sf-state">
                <Store aria-hidden />
                <h2>Nenhum estabelecimento vinculado</h2>
                <p>Adicione o estabelecimento onde você é atendido para agendar horários.</p>
                <button type="button" className="btn btn-primary btn-sm" onClick={() => setParams({ action: 'add' })}>
                    Adicionar estabelecimento
                </button>
            </div>
        );
    }

    return (
        <div className="sf-page mx-auto max-w-2xl px-2">
            <ul className="sf-group [--sf-row-inset:4.75rem]">
                {estabs.map((estab: any) => (
                    <li key={estab._id}>
                        <button type="button" className="sf-row" onClick={() => setOpenId(estab._id)}>
                            <span className="sf-thumb">
                                {estab.imageId ? (
                                    <img src={`${urlFile}/${estab.imageId}`} alt="" className="!object-contain p-1" />
                                ) : (
                                    <Store aria-hidden />
                                )}
                            </span>
                            <span className="sf-row-body">
                                <span className="sf-row-title">{estab.name}</span>
                                {[estab.address?.city, estab.address?.state].filter(Boolean).length > 0 && (
                                    <span className="sf-row-sub">
                                        {[estab.address?.city, estab.address?.state].filter(Boolean).join(' / ')}
                                    </span>
                                )}
                            </span>
                            <ChevronRight className="sf-chevron" aria-hidden />
                        </button>
                    </li>
                ))}
            </ul>

            {!!openId && <ViewEstabInfoModal estabId={openId} onClose={() => setOpenId('')} />}
        </div>
    );
};

export default function EstabelecimentosClient() {
    const { action } = useParamsContext();

    switch (action) {
        case 'add':
            return <UserClientEstabAdd />;

        default:
            return <MyEstablishments />;
    }
}
